import React from 'react';

import CurrencyConversionRow from './row';

function CurrencyConversionBody({ className, rows, availableCurrencies, isHiddenRub }) {
	return (
		<tbody className={className}>
			{rows.map((conversion) => (
				<CurrencyConversionRow
					conversion={conversion}
					isHiddenRub={isHiddenRub}
					availableCurrencies={availableCurrencies}
					key={conversion.date.toISOString()}
				/>
			))}
		</tbody>
	);
}

export default CurrencyConversionBody;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/currency-conversion-table/body.js